module.exports = __webpack_public_path__ + "img/faceai1.28488941.jpg";